module.exports = __webpack_public_path__ + "static/media/Door_Before.5329905d.jpg";